import { NavLink } from "react-router-dom";
import { NavBarLinkProps } from "./definitions";

// IDEA "manually adjust size with tailwind classes and style prop???"
// NOTE stroke = "lines", fill = "svg inner fill backdrop", bg = "svg icon background"
// NOTE the size of the svg depends on the button container for now

/** The link button for the navbar */
export const NavBarLink = ({
  to,
  replace,
  icon,
  className,
}: NavBarLinkProps) => {
  // const [disabledStyle, setDisabledStyle] = useState("");

  // useEffect(() => {
  //   setActiveStyle(classNames({ "!bg-primary": active }));
  //   setIconActiveStyle(classNames({ "!stroke-white": active }));
  //   setDisabledStyle(
  //     classNames({
  //       "!cursor-not-allowed grayscale text-white opacity-50": disabled,
  //     })
  //   );
  // }, []);

  return (
    <NavLink
      className={({ isActive }) =>
        isActive
          ? `group flex aspect-square cursor-pointer items-center justify-center rounded-lg bg-primary stroke-white p-2.5 text-white shadow-xl hover:bg-primary ${className}`
          : `group flex aspect-square cursor-pointer items-center justify-center rounded-lg bg-white stroke-primary p-2.5 text-transparent shadow-xl hover:bg-primary hover:text-white ${className}`
      }
      to={to}
      replace={replace}
    >
      <span className="bg-transparent stroke-inherit text-inherit group-hover:stroke-white">
        {icon}
      </span>
    </NavLink>
  );
};
